// ======================================================================
// FILE: src/modules/campaign/CampaignLayout.jsx
// MODULE: Campaign Management
// PURPOSE:
//   Main layout wrapper for Campaign module
//   - Includes Campaign Sidebar
//   - Handles content spacing
//   - Follows ERP module architecture
// ======================================================================

import React, { useState } from "react";

import CampaignSidebar
from "./layout/CampaignSidebar";

export default function CampaignLayout({
  children,
}) {

  const [
    sidebarExpanded,
    setSidebarExpanded
  ] = useState(true);

  return (

    <div
      style={{
        minHeight: "100vh",
        background: "#f3f4f6",
      }}
    >

      {/* SIDEBAR */}

      <CampaignSidebar
        onToggle={(expanded) =>
          setSidebarExpanded(
            expanded
          )
        }
      />

      {/* MAIN CONTENT */}

      <main
        style={{
          marginLeft:
            sidebarExpanded
              ? 260
              : 64,

          transition:
            "margin-left 0.22s ease",

          padding: 20,
        }}
      >
        {children}
      </main>

    </div>
  );
}